<template lang="pug">
.keyword-list
  aiq-tag.el-tag--keyword(v-for="keyword in list"
                          :key="keyword"
                          :closable="isDeletable(keyword)"
                          :close-transition="true"
                          type="info"
                          @close="deleteItem(keyword)")
    | {{ keyword }}
  slot
</template>

<script>
export default {
  name: 'aiq-keyword-list',
  props: {
    list: {
      type: Array,
      required: true,
    },
    deletable: {
      type: Boolean,
      default: () => false,
    },
    deletableExcept: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },

    isDeletable(item) {
      return this.deletable && !this.deletableExcept.includes(item);
    },
  },
};
</script>

<style lang="scss" scoped>
$keyword-padding: 6px;

.keyword-list {
  padding-top: $keyword-padding;
  display: flex;
  flex-wrap: wrap;
  min-height: 26px; //todo can we pull this from a var?
  overflow-x: hidden;

  .el-tag--keyword {
    cursor: default;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: $keyword-padding;
  }

  .el-tag--keyword:not(:last-of-type) {
    margin-right: $keyword-padding;
  }

  .el-tag--keyword {
    &+ :deep(.add-keyword.active) {
      margin-left: $keyword-padding;
    }
  }
}
</style>
